/**
 * @generated SignedSource<<2d6184c3b3dee972842b19ea6cd538be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type salesOrderPaymentsFragment$data = {
  readonly paymentIns: ReadonlyArray<{
    readonly amount: number;
    readonly createdAt: any | null;
    readonly currencyCode: string;
    readonly payerEmail: string;
    readonly externalRef: string;
    readonly salesOrder: {
      readonly id: string;
      readonly externalRef: string;
    };
  }>;
  readonly " $fragmentType": "salesOrderPaymentsFragment";
};
export type salesOrderPaymentsFragment$key = {
  readonly " $data"?: salesOrderPaymentsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"salesOrderPaymentsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalRef",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "salesOrderPaymentsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentIn",
      "kind": "LinkedField",
      "name": "paymentIns",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currencyCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "payerEmail",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "SalesOrder",
          "kind": "LinkedField",
          "name": "salesOrder",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SalesOrder",
  "abstractKey": null
};
})();

(node as any).hash = "c751142cdf524efaba6ec7751805a676";

export default node;
